/* eslint-disable no-unused-vars */
// import { store } from 'redux/store';
import _ from 'lodash';
import moment from 'moment';

// import { getDataPoints, getMoreInfoDataPoints } from '@pages/settings/helper';
import { getDataPoints, getMoreInfoDataPoints } from '../../pages/settings/helper';

import EquipmentSelector from '../equipment.selector';
import StructureSelector from '../structure.selector';
import PipelineSelector from '../pipeline.selector';
import { getAllWorkOrdersAndInspections } from './all-work-order-inspection-for-site';
import { getSitesInfoForSitesListingPage } from './sites-info-for-listing-page';

export const getParentSiteDetails = async ({
  siteId = '',
  equipmentsWithWO = false,
  withChild = true,
  templatesIds = '',
  store,
  getWorkRequestData = false,
  selectedTaskType = null
}) => {
  const { cache, picklists, settings, jurisdictionNumbers, structure, pipeline } = store;
  const {
    sitesMap = {},
    equipmentsMap = {},
    sitesLoading = {},
    sitesEquipmentsMap = {},
    equipments: cacheEquipments = [],
    sites: cacheSites = []
  } = cache;
  const { sitePipelineCountMap } = pipeline;

  const { structure: cacheStructures, sitesStructuresMap, structuresMap } = structure;

  const { jurisdictionNumbersMap = {} } = jurisdictionNumbers;
  const structureDisplayFields = settings?.settings?.['structureDisplayFields'] || '';

  const equipmentDisplayFields = settings.settings?.['equipmentDisplayFields'] || '';
  const siteDisplayFields = settings.settings?.['siteDisplayFields'] || '';

  const { assignedTasksList: tasksList, hseEvents } =
    selectedTaskType !== 'NewOrEditAsset'
      ? await getAllWorkOrdersAndInspections({
          siteId,
          store,
          recordsCount: true,
          query: selectedTaskType
        })
      : {
          assignedTasksList: [],
          hseEvents: [],
          newWorkRequestList: [],
          onDemandRecordList: [],
          newWorkOrderList: []
        };

  const { picklistsMap = {}, areaHierarchyTreeDataMap = {} } = picklists;
  const parentSite = cacheSites[sitesMap[siteId]] || {};

  let parentSiteWithWorkOrders = await getSitesInfoForSitesListingPage({
    parentSite: [parentSite || ''],
    templatesIds,
    withChild,
    store,
    getWorkRequestData: getWorkRequestData,
    siteTypeQuery: selectedTaskType
  });

  const parentSiteChildrenCompleteInfo = parentSite?.children?.map((x) => cacheSites[x]);

  const parentSitesWithMeta =
    _.size([...(parentSite?.children || [])]) > 0
      ? await getSitesInfoForSitesListingPage({
          parentSite: [...(parentSiteChildrenCompleteInfo || [])], // indexes,
          templatesIds,
          withChild,
          store,
          siteTypeQuery: selectedTaskType
        })
      : [];

  const children = parentSitesWithMeta?.sort(
    (a, b) =>
      (a.distance != null ? a.distance : Infinity) - (b.distance != null ? b.distance : Infinity) ||
      a.name.localeCompare(b.name)
  );

  let equipments = [
    ...(sitesEquipmentsMap[siteId] || []),
    ...children.reduce((acc, { siteId }) => {
      acc = acc.concat(sitesEquipmentsMap[siteId] || []);
      return acc;
    }, [])
  ].filter((id) => cacheEquipments[equipmentsMap[id]]);

  const structures =
    [
      ...(sitesStructuresMap[siteId] || []),
      ...children.reduce((acc, { siteId }) => {
        acc = acc.concat(sitesStructuresMap[siteId] || []);
        return acc;
      }, [])
    ].filter((id) => cacheStructures[structuresMap[id]]) || [];

  const pipelines = await PipelineSelector.getPipelineWithWO({ store });
  const parentPipelines = pipelines.filter((p) => {
    return (
      p?.fromSite === siteId ||
      p?.toSite === siteId ||
      p?.sites?.some((x) => x?.toLowerCase() === siteId) ||
      p?.wells?.some((x) => x?.toLowerCase() === siteId)
    );
  });

  const childrenPipelines = pipelines.filter((p) => {
    const hasChildStructure = children.some((child) => {
      return (
        child.siteId === p.fromSite ||
        child.siteId === p.toSite ||
        (p.sites && p.sites.some((x) => x?.toLowerCase() === child.siteId)) ||
        (p.wells && p.wells.some((x) => x?.toLowerCase() === child.siteId))
      );
    });
    return hasChildStructure;
  });

  const particularPipelines = [...parentPipelines, ...childrenPipelines];

  let equipmentsWithWOData = [];
  if (equipmentsWithWO) {
    equipmentsWithWOData = await EquipmentSelector.getEquipmentsWithAllTasks({
      parentEquipment: equipments.map((id) => cacheEquipments[equipmentsMap[id]]),
      store,
      onlyTaskCount: true
    });

    equipmentsWithWOData = equipmentsWithWOData?.map((props) => {
      const { jurisdictionNumber } = jurisdictionNumbersMap[props.equipmentId] || {};

      const dataPoints = getDataPoints(
        { ...props, subtype: props.equipmentSubType, jurisdictionNumber },
        equipmentDisplayFields,
        'equipment',
        picklistsMap
      );

      return {
        ...props,
        dataPoints
      };
    });
  }

  const structureEquipmentMap =
    structures?.length > 0
      ? await StructureSelector.getStructuresWithWO({ store, ids: structures })
      : [];

  const siteTypeQueryCondition = !selectedTaskType
    ? true
    : selectedTaskType &&
      [
        'Check',
        'check',
        'Inspection',
        'inspection',
        'workOrder',
        'Work Order',
        'workRequest',
        'Work Request',
        'hseEvents'
      ].includes(selectedTaskType)
    ? false
    : true;

  const childSiteIds = parentSiteChildrenCompleteInfo?.map((x) => x?.siteId) || [];

  const { pvPsv } = store;
  let equipmentIdsWithPSVAndVesselIds = [];
  const { pvPsvMap = {} } = pvPsv;
  for (let eqId of equipments) {
    const { pv = [], psv = [] } = pvPsvMap[eqId] || {};
    equipmentIdsWithPSVAndVesselIds = [...equipmentIdsWithPSVAndVesselIds, ...psv, ...pv];
  }

  // const allPSVAndVesselsOfTheEquipment =
  //   equipmentIdsWithPSVAndVesselIds?.length > 0 && equipments?.length > 0 && siteTypeQueryCondition
  //     ? await EquipmentSelector.getAllEquipmentsThatIsEditedAndNewCreates({
  //         store,
  //         equipmentIds: equipmentIdsWithPSVAndVesselIds,
  //         siteId,
  //         sitesListingPage: true
  //       })
  //     : [];

  const allEditEquipmentAssets =
    (equipments?.length > 0 || siteId || childSiteIds?.length > 0) && siteTypeQueryCondition
      ? await EquipmentSelector.getAllEquipmentsThatIsEditedAndNewCreates({
          store,
          equipmentIds: equipments,
          siteId,
          sitesListingPage: true,
          childSiteIds
        })
      : [];

  return new Promise((resolve) => {
    const { name, siteType, areaHierarchy, link, latitude, longitude } = parentSite;

    const status = picklistsMap[parentSite.status]?.value;
    const area = areaHierarchyTreeDataMap[areaHierarchy]?.title;
    const data = { ...parentSite, area, type: siteType };
    const { unit, distance, children: c, ...rest } = data;

    const allTasksForSite = [
      ...tasksList,
      ...(children?.map((t) => t.allTasksForSite).flat(2) || [])
    ];
    const allHSEEventsForSite = [
      ...hseEvents,
      ...(children?.map((t) => t?.hseEvents).flat(2) || [])
    ];

    const allNotDoneTasks = _.flattenDeep(allTasksForSite).filter(
      (task) => task?.status !== 'Synced'
    );

    const allWorkOrders =
      _.size(parentSiteWithWorkOrders) > 0 &&
      parentSiteWithWorkOrders[0]?.allTasksForSite?.filter((x) => x.type === 'Work Order').length >
        0
        ? parentSiteWithWorkOrders[0]?.allTasksForSite?.filter((x) => x.type === 'Work Order')
        : [];
    const allDoneWorkOrders =
      _.size(parentSiteWithWorkOrders) > 0 &&
      parentSiteWithWorkOrders[0]?.allDoneTasks?.filter((x) => x.type === 'Work Order').length > 0
        ? parentSiteWithWorkOrders[0]?.allDoneTasks?.filter((x) => x.type === 'Work Order')
        : [];

    const allNotDoneWorkOrders = _.flattenDeep(allWorkOrders).filter(
      (task) => task?.status !== 'Synced'
    );
    const allInspections =
      _.size(parentSiteWithWorkOrders) > 0 &&
      parentSiteWithWorkOrders[0]?.allTasksForSite?.filter((x) => x.type === 'Inspection').length >
        0
        ? parentSiteWithWorkOrders[0]?.allTasksForSite?.filter((x) => x.type === 'Inspection')
        : [];
    const allDoneInspections =
      _.size(parentSiteWithWorkOrders) > 0 &&
      parentSiteWithWorkOrders[0]?.allDoneTasks?.filter((x) => x.type === 'Inspection').length > 0
        ? parentSiteWithWorkOrders[0]?.allDoneTasks?.filter((x) => x.type === 'Inspection')
        : [];

    const allNotDoneInspections = _.flattenDeep(allInspections).filter(
      (task) => task?.status !== 'Synced'
    );

    const allChecks =
      _.size(parentSiteWithWorkOrders) > 0 &&
      parentSiteWithWorkOrders[0]?.allTasksForSite?.filter((x) => x.type === 'Check').length > 0
        ? parentSiteWithWorkOrders[0]?.allTasksForSite?.filter((x) => x.type === 'Check')
        : [];

    const allDoneChecks =
      _.size(parentSiteWithWorkOrders) > 0 &&
      parentSiteWithWorkOrders[0]?.allDoneTasks?.filter((x) => x.type === 'Check').length > 0
        ? parentSiteWithWorkOrders[0]?.allDoneTasks?.filter((x) => x.type === 'Check')
        : [];

    const allNotDoneChecks = _.flattenDeep(allChecks).filter((task) => task?.status !== 'Synced');

    const today = moment().format('YYYY-MM-DD');
    const isOverDue = allNotDoneTasks.find((task) =>
      task.dueDate ? moment(task.dueDate).isBefore(today) : false
    );

    const isInspectionOverDue = allNotDoneInspections.find((task) =>
      task.dueDate ? moment(task.dueDate).isBefore(today) : false
    );

    const isCheckOverDue = allNotDoneChecks.find((task) =>
      task.nextDue ? moment(task.nextDue).isBefore(today) : false
    );
    const isWorkOrderOverDue = allNotDoneWorkOrders.find((task) =>
      task.dueDate ? moment(task.dueDate).isBefore(today) : false
    );
    const dataPoints = getDataPoints(
      { ...data, type: data?.siteType },
      siteDisplayFields,
      'site',
      picklistsMap
    );
    const dataPointsMap = dataPoints.reduce((acc, curr) => {
      acc[curr.Id] = curr;
      return acc;
    }, {});
    dataPointsMap['Status'] = { value: status, title: 'Status' };

    const MoreInfoDataPoints = getMoreInfoDataPoints(
      { ...data, type: data?.siteType },
      'site',
      picklistsMap
    );
    const MoreInfoDataPointsMap = MoreInfoDataPoints.reduce((acc, curr) => {
      acc[curr.Id] = curr;
      return acc;
    }, {});
    MoreInfoDataPointsMap['Status'] = { value: status, title: 'Status' };

    const allSiteAndItsChildTasksList =
      _.size(parentSiteWithWorkOrders) > 0 && parentSiteWithWorkOrders[0]?.allTasksForSite
        ? parentSiteWithWorkOrders[0]?.allTasksForSite
        : [];
    const allWorkRequestListSyncedAndInprogress =
      _.size(parentSiteWithWorkOrders) > 0 &&
      parentSiteWithWorkOrders[0]?.allWorkRequestListSyncedAndInprogress;

    const alNewWorkOrderListSyncedAndInprogress =
      _.size(parentSiteWithWorkOrders) > 0 &&
      parentSiteWithWorkOrders[0]?.alNewWorkOrderListSyncedAndInprogress;

    let equipmentCountList = 0;

    for (let x of [...(children || []), ...[{ siteId: siteId }]]) {
      let find = sitesEquipmentsMap[x?.siteId]?.length || 0;
      if (find) {
        equipmentCountList += find;
      }
    }

    let structureCountList = 0;

    for (let x of [...(children || []), ...[{ siteId: siteId }]]) {
      let find = sitesStructuresMap[x?.siteId]?.length || 0;
      if (find) {
        structureCountList += find;
      }
    }

    let pipelineCountList = 0;

    for (let x of [...(children || []), ...[{ siteId: siteId }]]) {
      let find = sitePipelineCountMap[x?.siteId]?.length || 0;
      if (find) {
        pipelineCountList += find;
      }
    }

    const structureAllFieldData = structureEquipmentMap?.filter((x) => {
      return [...(children || []), ...[{ siteId: siteId }]]?.find((y) => y?.siteId === x?.siteId);
    });

    return resolve({
      sitesLoading,
      allOnDemandRecordCount:
        _.size(parentSiteWithWorkOrders) > 0
          ? parentSiteWithWorkOrders[0]?.allOnDemandRecordCount || 0
          : 0,
      name,
      tasks: allSiteAndItsChildTasksList,
      allDoneTasks:
        _.size(parentSiteWithWorkOrders) > 0 && parentSiteWithWorkOrders[0]?.allDoneTasks
          ? parentSiteWithWorkOrders[0]?.allDoneTasks
          : [],
      allWorkOrders,
      allDoneWorkOrders,
      allInspections,
      allDoneInspections,
      isInspectionOverDue,
      isOverDue,
      allChecks,
      allDoneChecks,
      isCheckOverDue,
      isWorkOrderOverDue,
      status,
      area,
      equipments,
      structures,
      structuresMap: structureEquipmentMap?.length > 0 ? structuresMap : [],
      equipmentsMap,
      dataPoints,
      unit,
      distance,
      children,
      parentSite,
      rest,
      dataPointsMap,
      MoreInfoDataPointsMap,
      equipmentsWithWO: equipmentsWithWOData,
      structureAllFieldData,
      pipelines: particularPipelines,
      link,
      newWorkRequestList: allWorkRequestListSyncedAndInprogress,
      newWorkOrderList: alNewWorkOrderListSyncedAndInprogress,
      newChecksList: [],
      newInspectionList: [],
      hseEvents: allHSEEventsForSite,
      latitude,
      longitude,
      equipmentCount: equipmentCountList || 0,
      structureCount: structureCountList || 0,
      pipelineCount: pipelineCountList || 0,
      allEditEquipmentAssets
    });
  });
};
